import React from "react";
var __jsx = React.createElement;
import stl from "./LabelsCA.module.css";
var LabelsCA = function LabelsCA(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: [stl.lblCAContainer, props.hasBrdr ? stl.hasBrdr : undefined, "mb-3"].join(" ")
  }, props.tags && props.tags.map(function (tag, idx) {
    return /*#__PURE__*/React.createElement("label", {
      key: "lbl" + idx,
      style: {
        backgroundColor: tag.background_color ? tag.background_color : "",
        color: tag.text_color ? tag.text_color : ""
      }
    }, tag.icon && /*#__PURE__*/React.createElement("img", {
      width: "10px",
      src: tag.icon,
      alt: "icon"
    }), /*#__PURE__*/React.createElement("span", null, tag.tag_name, " ", tag.attr && /*#__PURE__*/React.createElement("span", null, tag.attr)));
  }));
};
export default LabelsCA;